<template>
  <div class="ui grid">
    <div class="row">
      <h1 class="ui huge header">{{ $t('studentSelectionTitle') }}</h1>
    </div>
    <div class="row" v-if="test.expired">
      <p class="ui negative message">
        {{ $t('testExpired') }}
      </p>
    </div>
    <div v-else>
      <div v-if="!test.completed" class="row">
        <student-table
          v-bind:students="studentList"
          v-bind:actions="actions"
          v-on:rowAction="rowAction"
        />
      </div>
      <div v-if="test.completed || studentList.length === 0" row="row">
        <p class="ui negative message">{{ $t('testAlreadyCompleted') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import StudentTable from '@/components/students/StudentTable';
import { mapGetters } from 'vuex';

export default {
  name: 'StudentSelection',
  components: { StudentTable },
  computed: {
    studentList() {
      return (
        this.students
          // eslint-disable-next-line arrow-parens
          .filter((s) => s.submitted === false)
          // eslint-disable-next-line arrow-parens
          .map((s) => s.student)
      );
    },
    ...mapGetters({
      students: 'students',
      test: 'test',
    }),
  },
  data() {
    return {
      actions: [this.$t('studentSelectionButton')],
    };
  },
  methods: {
    rowAction(action) {
      if (action.action === this.$t('studentSelectionButton')) {
        this.$dialog
          .confirm(
            this.$t('studentSelectionConfirmationText', {
              firstName: action.student.firstName,
              lastName: action.student.lastName,
            }),
            {
              okText: this.$t('studentSelectionConfirmationContinueButton'),
              cancelText: this.$t('studentSelectionConfirmationCancelButton'),
            },
          )
          .then(() => {
            this.$store.dispatch('selectStudent', action.student);
            this.$router.push('/test/execute');
          })
          .catch(() => {});
      }
    },
  },
  created() {
    this.$store.dispatch('refreshTest');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/students/StudentSelection.vue